<template lang="pug">
  .type-redactor(:class="color" @click="handleClick" @mouseover="handleMouseOver")
    .cases(v-if="currentCategory === 0")
      h2.f-0 {{ partyOne }} v.
      .two
        h2.f-0 {{ partyTwo }}
    .latin(v-if="currentCategory === 1")
      h2.f-0.i.st {{ currentText }}
    .statement(v-if="currentCategory === 2")
      h2.f-0.stand(v-for="t in currentText") {{ t }}
</template>

<script>
import cases from "@/assets/data/cases.json";
import { mapActions } from "vuex"

export default {
  name: "FontSlider",

  props: ["activeId", "color"],

  data() {
    return {
      bitmap: false,
      images: new Array(5),
      imagesWhite: new Array(5),
      courtCases: cases,
      currentCategory: 0,
      caseIndex: 0,
      latinIndex: 0,
      statementIndex: 0,
      latinLimit: 0,
      statementLimit: 0,
      caseLimit: 0,
      latin: [
        'ad litem',
        'affidavit',
        'amicus curiae',
        'bona fide',
        'certiorari',
        'de novo',
        'ex officio',
        'ex parte',
        'habeas corpus',
        'in forma pauperis',
        'in camera',
        'mandamus',
        'mens rea',
        'per curium',
        'quantum meruit',
        'sua sponte',
        'verum dicere'
      ],
      statements: [
        ['STAND', 'YOUR', 'GROUND'],
        ['BLACK', 'LIVES', 'MATTER'],
        ['STOP', 'AND', 'FRISK'],
        ['LOVE', 'TRUMPS', 'HATE'],
        ['MAKE', 'YOUR', 'MOVE'],
        ['WAR', 'IS', 'OVER'],
        ['ENEMY', 'OF THE' ,'STATE'],
        ['DRAIN', 'THE SWAMP'],
        ['ALTERNATIVE', 'FACTS'],
        ['COVFEFE'],
        ['RECLAIMING', 'MY TIME'],
        ['FAKE NEWS'],
        // ['NEVERTHELESS,', 'SHE PERSISTED'],
        ['FUZZY MATH'],
        ['AXIS OF EVIL'],
        ['FIRST', 'WORLD', 'PROBLEMS'],
        ['CITIZENS', 'UNITED'],
        ['ACTIVIST', 'JUDGES'],
        ['PARTY', 'OF REAGAN'],
        ['TALKING', 'POINTS']
      ]
    };
  },

  computed: {
    currentText() {
      let text
      if (this.currentCategory === 0) {
        text = this.courtCases.cases[this.caseIndex]
      } else if (this.currentCategory === 1) {
        text = this.latin[this.latinIndex]
      } else if (this.currentCategory === 2) {
        text = this.statements[this.statementIndex]
      }
      return text;
    },

    partyOne() {
      return this.currentText.partyOne;
    },

    partyTwo() {
      return this.currentText.partyTwo;
    }
  },

  methods: {
    ...mapActions({
      setCircleVisibility: 'setCircleVisibility'
    }),

    handleClick() {
      this.currentCategory = (this.currentCategory + 1) % 3

      if (this.currentCategory === 0) {
        this.caseIndex = Math.floor(Math.random() * this.caseLimit)
        console.log(this.currentCategory, this.caseIndex, this.caseLimit)
      } else if (this.currentCategory === 1) {
        this.latinIndex = Math.floor(Math.random() * this.latinLimit)
        console.log(this.currentCategory, this.latinIndex, this.latinLimit)
      } else if (this.currentCategory === 2) {
        this.statementIndex = Math.floor(Math.random() * this.statementLimit)
        console.log(this.currentCategory, this.statementIndex, this.statementLimit)
      }
    },

    handleMouseOver() {
      this.setCircleVisibility(false)
    }
  },

  mounted() {
    this.latinLimit = this.latin.length
    this.caseLimit = this.courtCases.cases.length
    this.statementLimit = this.statements.length
  }
};
</script>

<style lang="sass">
@import '@/styles/_variables.sass'
.type-redactor
  width: 100vw
  height: 130vh
  display: none
  justify-content: center
  align-items: center
  flex-direction: column
  cursor: none
  position: relative
  @media only screen and (min-width: $m)
    display: flex
  h2
    font-size: 12vw
    line-height: 12.1vw
    user-select: none
    text-align: center
    margin-bottom: 2rem
    &.stand
      font-size: 12vw
      line-height: 12.1vw
      font-weight: bold
    &.st
      position: relative
      &::after
        border-bottom: 1rem solid #000
        content: ""
        left: 0
        position: absolute
        right: 0
        top: 50%
        transform: translate(0, -50%)
      &:hover
        &::after
          border-bottom: 1rem solid rgba(0, 0, 0, 0)
          content: ""
          left: 0
          position: absolute
          right: 0
          top: 50%
          transform: translate(0, -50%)
  .two
    display: flex
    justify-content: center
    h2
      background-color: #000
      color: #000
      padding: 1rem 6rem
      display: inline-block
      &:hover
        color: #FFF
  .statement
    &:hover
      *
        font-family: 'Redaction 100'
</style>
